// Thunks extracted from ResourceBankModule.js

import { addUnsplashAnalyticsMutation } from "ResourceBank/containers/Mutations";
import client from "lib/apolloClient/client";

// Thunks
export const addUnsplashAnalytics = ({ url }) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: addUnsplashAnalyticsMutation,
        variables: {
          url,
        },
      });
    } catch (e) {
    } finally {
      /* empty */
    }
  };
};
